import {
  Button,
  CloseButton,
  SettingsButton,
  SaveButton,
} from '@ui/shared/Button';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import {
  closePopup,
  openPopup,
} from '../../../../data/providers/popupsProvider';
import {
  dsiReportSettingsProvider,
  IDsiReportSettings,
} from '../../../../data/providers/settings/reports/dsiReportSettingsProvider';
import { updateDSISettings } from '../../../../data/writers/settings/reports/dsiReportSettings';
import { Column } from '../../../layout/Column';
import { CardBody } from '../../../shared/card/CardBody';
import {
  CardFooter,
  CardFooterLeft,
  CardFooterRight,
} from '../../../shared/card/CardFooter';
import {
  CardHeader,
  CardHeaderLeft,
  CardHeaderRight,
} from '../../../shared/card/CardHeader';
import { LinearLoading } from '../../../shared/loading/LinearLoading';
import { PopupCard, PopupCardContent } from '../../../shared/popups/PopupCard';
import { DSIForm } from './Form';
interface IPopupProps {
  onClose: () => void;
  onSave: () => void;
}

export const Popup = (props: IPopupProps): React.ReactElement => {
  const [loading, setLoading] = React.useState<boolean>(true);
  const [settings, setSettings] = React.useState<IDsiReportSettings>();

  /**
   * @description subscribe to trend report settings
   */
  React.useEffect((): (() => void) => {
    const subscriber = dsiReportSettingsProvider().subscribe(
      (mSettings: IDsiReportSettings): void => {
        setSettings(mSettings);
        setLoading(false);
      }
    );

    return (): void => subscriber.unsubscribe();
  }, []);

  /**
   * @description saves the change to database
   */
  const handleSave = async (): Promise<void> => {
    props.onSave();
    setLoading(true);
    await updateDSISettings(settings);
    props.onClose();
  };

  return (
    <PopupCard onClose={props.onClose} size='medium' noClickOutside>
      <PopupCardContent>
        <CardHeader surface={8}>
          <CardHeaderLeft>
            <h6>DSI Report Settings</h6>
          </CardHeaderLeft>
          <CardHeaderRight>
            <CloseButton onClick={props.onClose} />
          </CardHeaderRight>
        </CardHeader>
        <CardBody>
          {loading && <LinearLoading />}
          <Column>
            <DSIForm settings={settings} onSettingsChange={setSettings} />
          </Column>
        </CardBody>
        <CardFooter surface={8}>
          <CardFooterLeft />
          <CardFooterRight>
            <SaveButton onClick={handleSave} disabled={loading} />
          </CardFooterRight>
        </CardFooter>
      </PopupCardContent>
    </PopupCard>
  );
};

interface IProps extends RouteComponentProps {
  style?: React.CSSProperties;
  onSave: () => void;
}
export const DSISettings = withRouter((props: IProps): React.ReactElement => {
  const open = (): void =>
    openPopup(
      <Popup onClose={closePopup(props.history)} onSave={props.onSave} />,
      props.history,
      'dsi-report-settings'
    );

  return <SettingsButton onClick={open} />;
});
